var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusSeatLadies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bus-seat-ladies_svg__a",
    d: "M.078 2.273A2.247 2.247 0 012.336.038h9.935c1.247 0 2.258 1 2.258 2.235v9.252a2.246 2.246 0 01-2.258 2.236H2.336a2.247 2.247 0 01-2.258-2.236V2.273z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 8.25 8.25)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bus-seat-ladies_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bus-seat-ladies_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#8F908C",
    strokeWidth: 0.75,
    d: "M.078 2.273A2.247 2.247 0 012.336.038h9.935c1.247 0 2.258 1 2.258 2.235v9.252a2.246 2.246 0 01-2.258 2.236H2.336a2.247 2.247 0 01-2.258-2.236V2.273h0z",
    mask: "url(#bus-seat-ladies_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FA3988",
    d: "M13.05 3.76H6.613a.606.606 0 01-.614-.598V1.217c0-.33.275-.598.614-.598h8.772c.339 0 .614.268.614.598v15.537-.008.216a.605.605 0 01-.613.598H6.614A.606.606 0 016 16.962v-1.945c0-.33.275-.598.614-.598h6.435V3.76z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7C7E7A",
    strokeWidth: 0.75,
    d: "M13.05 3.76H6.613a.606.606 0 01-.614-.598V1.217c0-.33.275-.598.614-.598h8.772c.339 0 .614.268.614.598v15.537-.008.216a.605.605 0 01-.613.598H6.614A.606.606 0 016 16.962v-1.945c0-.33.275-.598.614-.598h6.435V3.76z"
  }))));
}
export default SvgBusSeatLadies;